import { useAppDispatch } from "@features/store/store";
import { changeMood } from "Header/store/headerSlice";
import { useCurrentTheme } from "Header/store/selector";
import React, { useEffect } from "react";

interface IMoodProviderProps {
    children: React.ReactNode;
}

export const MoodProvider: React.FC<IMoodProviderProps> = ({ children }) => {
    const dispatch = useAppDispatch();
    const themeMode = useCurrentTheme();

    useEffect(() => {
        const savedTheme = localStorage.getItem("theme");

        if (savedTheme) {
            document.body.setAttribute("data-theme", savedTheme);
            dispatch(changeMood(savedTheme === "dark"));
        }
    }, []);

    useEffect(() => {
        document.body.setAttribute("data-theme", themeMode);
        localStorage.setItem("theme", themeMode);
    }, [themeMode]);

    return <>{children}</>;
};
